import { Box, Stack, Typography } from "@mui/material";
import DocumentDialogIcon from "@entrilia/shared/icons/DocumentDialogIcon";

interface Props {
  text: string;
}

const EmptyDocumentPreview = ({ text }: Props) => (
  <Box
    sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexGrow: 1, width: "100%", height: "100%" }}
  >
    <Stack spacing={2} sx={{ alignItems: "center" }}>
      <DocumentDialogIcon sx={{ width: 80, height: 80 }} />
      <Typography color="textSecondary">{text}</Typography>
    </Stack>
  </Box>
);

export default EmptyDocumentPreview;
